import React, { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import PasswordChangeModal from './PasswordChangeModal';

interface PasswordChangeWrapperProps {
  children: React.ReactNode;
}

const PasswordChangeWrapper: React.FC<PasswordChangeWrapperProps> = ({ children }) => {
  const { token, clearPasswordChangeFlag } = useAuth();
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  useEffect(() => {
    // Check if user needs to change password
    const mustChangePassword = localStorage.getItem('mustChangePassword') === 'true';
    if (mustChangePassword && token) {
      setShowPasswordModal(true);
    }
  }, [token]);

  const handlePasswordChangeSuccess = () => {
    clearPasswordChangeFlag();
    setShowPasswordModal(false);
  };

  return (
    <>
      {children}
      <PasswordChangeModal
        isOpen={showPasswordModal}
        onClose={() => {}} // Prevent closing - user must change password
        onSuccess={handlePasswordChangeSuccess}
        token={token || ''}
      />
    </>
  );
};

export default PasswordChangeWrapper;
